import { render, staticRenderFns } from "./SuggestedCarriers.vue?vue&type=template&id=4bd265e7&scoped=true&"
import script from "./SuggestedCarriers.vue?vue&type=script&lang=js&"
export * from "./SuggestedCarriers.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedCarriers.vue?vue&type=style&index=0&id=4bd265e7&lang=scss&scoped=true&"
import style1 from "./SuggestedCarriers.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd265e7",
  null
  
)

export default component.exports